import { Link } from 'react-router-dom';
import { ArrowRight, ExternalLink, Calendar, Camera } from 'lucide-react';
import SEO from '../components/SEO';

const galleryAlbums = [
  {
    id: 1,
    title: 'AI Expo Nov 2025',
    date: 'November 2025',
    type: 'EXPO',
    link: 'https://photos.app.goo.gl/xTY9rnMVRMEa8Hds5',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/ktw2sp3a_world-ai-expo.jpg',
  },
  {
    id: 2,
    title: 'Awards Gala Ceremony Nov 2025',
    date: 'November 2025',
    type: 'CEREMONY',
    link: 'https://photos.app.goo.gl/Y7eZZT3ecnmgXrp48',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/kqq8r3lj_Arabian-Best-of-Best-Awards.jpg',
  },
  {
    id: 3,
    title: 'Awards Gala Ceremony Jun 2025',
    date: 'June 2025',
    type: 'CEREMONY',
    link: 'https://photos.app.goo.gl/WFkwRd6TE1WhWmGeA',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/6ztcpbij_europe-best-of-best-awards.jpg',
  },
  {
    id: 4,
    title: 'AI Expo May 2025',
    date: 'May 2025',
    type: 'EXPO',
    link: 'https://photos.app.goo.gl/omyDufZfPVjFVbR59',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/bf45yk6j_World-Entrepreneur-Investor-Summit.jpg',
  },
  {
    id: 5,
    title: 'Awards Gala Ceremony Dec 2024',
    date: 'December 2024',
    type: 'CEREMONY',
    link: 'https://photos.app.goo.gl/GQMx6WVPxGmyZUs48',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/9rmv3cqj_world-beauty-awards.jpg',
  },
  {
    id: 6,
    title: 'Awards Gala Ceremony Sep 2024',
    date: 'September 2024',
    type: 'CEREMONY',
    link: 'https://photos.app.goo.gl/BJMeBusujWDjs8My9',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/08cyfp9t_World-CEO-Awards.jpg',
  },
  {
    id: 7,
    title: 'Awards Gala Ceremony Dec 2023',
    date: 'December 2023',
    type: 'CEREMONY',
    link: 'https://photos.app.goo.gl/qcEDTsUSdK8YTT5B9',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/5q7tt4x3_Golden-Women-Awards.jpg',
  },
  {
    id: 8,
    title: 'Awards Gala Ceremony Jun 2023',
    date: 'June 2023',
    type: 'CEREMONY',
    link: 'https://photos.app.goo.gl/JfGRcYg5E1LZ62bB8',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/86xuskp6_World-GM-Awards.jpg',
  },
];

export const GalleryPage = () => {
  return (
    <main data-testid="gallery-page" className="pt-24 min-h-screen bg-[#0a0a0a]">
      <SEO 
        title="Event Gallery - Photos from Our Award Ceremonies & Expos"
        description="Browse our event gallery featuring photos from award gala ceremonies, AI expos, and business summits. See highlights from Golden Tree Events worldwide."
        keywords="event photos, award ceremony gallery, gala photos, expo images, Golden Tree Events gallery"
      />
      {/* Hero Section */}
      <section className="py-16 md:py-24 border-b border-white/10">
        <div className="w-full px-4 sm:px-8 lg:px-16">
          <div className="text-center">
            <p className="font-google-sans text-[#D4AF37] text-xs tracking-[0.3em] uppercase mb-4">Event Gallery</p>
            <h1 className="font-montserrat text-4xl sm:text-5xl lg:text-6xl text-white mb-6">
              Our <span className="gradient-gold">Portfolio</span>
            </h1>
            <p className="font-google-sans text-[#A1A1AA] text-lg max-w-2xl mx-auto">
              A glimpse into the world-class events we've created. 
              Browse through our collection of memorable moments.
            </p>
          </div>
        </div>
      </section>

      {/* Gallery Cards Grid */}
      <section className="py-16">
        <div className="w-full px-4 sm:px-8 lg:px-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {galleryAlbums.map((album) => (
              <a
                key={album.id}
                href={album.link}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`gallery-album-${album.id}`}
                className="group bg-[#121212] border border-white/10 hover:border-[#D4AF37]/30 transition-all duration-500 overflow-hidden"
              >
                {/* Image */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={album.image}
                    alt={album.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                  
                  {/* Type Badge */}
                  <div className="absolute top-3 left-3">
                    <span className="bg-[#D4AF37] text-black text-xs font-bold px-2.5 py-1 uppercase tracking-wider">
                      {album.type}
                    </span>
                  </div>

                  {/* External Link Icon */}
                  <div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="w-8 h-8 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center">
                      <ExternalLink className="w-4 h-4 text-white" />
                    </div>
                  </div>
                </div>

                {/* Content */}
                <div className="p-5">
                  <h3 className="font-montserrat text-white text-lg mb-2 group-hover:text-[#D4AF37] transition-colors">
                    {album.title}
                  </h3>
                  <div className="flex items-center gap-2 text-[#A1A1AA] text-sm">
                    <Calendar className="w-4 h-4" />
                    <span>{album.date}</span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-[#121212]">
        <div className="w-full px-4 sm:px-8 lg:px-16 text-center">
          <h2 className="font-montserrat text-3xl sm:text-4xl text-white mb-4">
            Want Your Event in Our Gallery?
          </h2>
          <p className="font-google-sans text-[#A1A1AA] mb-8">
            Let us create unforgettable moments for your next event.
          </p>
          <Link
            to="/contact-us"
            data-testid="gallery-contact-cta"
            className="inline-flex items-center gap-2 bg-[#D4AF37] text-black font-medium px-8 py-4 uppercase tracking-widest text-sm hover:bg-[#C5A028] transition-all duration-300"
          >
            Plan Your Event
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </main>
  );
};

export default GalleryPage;
